import * as React from "react";

import { cn } from "@/utils/helpers";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-xl border border-input bg-inputField px-4 py-3 text-sm ring-offset-background placeholder:text-muted-foreground placeholder:opacity-70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };

// Recycled

// 18 Feb 2026

// export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}
